import { all, fork } from 'redux-saga/effects';

import session from './session';
import page from './page';
import activity from './activity';
import domain from './domain';
import gallery from './gallery';
import editor from './editor';
import lead from './lead';
import profile from './profile';
import plan from './plan';
import payment from './payment';
import app from './app';


export default function* root() {
  yield all([
    fork(session),
    fork(page),
    fork(activity),
    fork(domain),
    fork(gallery),
    fork(editor),
    fork(lead),
    fork(profile),
    fork(plan),
    fork(payment),
    fork(app),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/index.js